import React from 'react';
import { Card, Skeleton, Typography } from '@mui/joy';

export interface DirectMailStatTileProps {
  label: string;
  value: React.ReactNode;
  hint?: string;
  loading?: boolean;
  selected?: boolean;
  onClick?: () => void;
}

export const DirectMailStatTile: React.FC<DirectMailStatTileProps> = ({
  label,
  value,
  hint,
  loading = false,
  selected = false,
  onClick,
}) => (
  <Card
    variant={selected ? 'solid' : 'soft'}
    color={selected ? 'primary' : 'neutral'}
    onClick={onClick}
    sx={{
      p: 1.5,
      gap: 0.25,
      height: '100%',
      cursor: onClick ? 'pointer' : 'default',
      '&:hover': onClick ? { boxShadow: 'sm' } : undefined,
    }}
  >
    <Typography level="body-xs" sx={{ color: selected ? 'inherit' : 'text.tertiary' }}>
      {label}
    </Typography>
    <Typography level="h3" sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
      {loading ? <Skeleton variant="text" level="h3" width={56} /> : value}
    </Typography>
    {hint && (
      <Typography level="body-xs" sx={{ color: selected ? 'inherit' : 'text.tertiary' }}>
        {hint}
      </Typography>
    )}
  </Card>
);
